import React from 'react';
import { getData, deleteData, } from '../../../core/HttpAction';
import Table from '../../../core/Table'; 
import {withRouter} from 'react-router-dom';
const Url='/fine-setting';
const columns=[
    {
        key:'title',
        displayName:'Title'
    }, 
    {
        key:'member_type',
        displayName:'Member Type'
    }, 
    {
        key:'penalty_type',
        displayName:'Penalty Type'
    }, 
    {
        key:'fine_amount',
        displayName:'amount'
    },
    {
        key:'status',
        displayName:'status'
    },
    
];
  
class ListPage extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            params:{
                search_term: '',
                startDate: '',
                endDate:'', 
                limit:10,
                page:1
            }, 
            data:[],
            preloader:true,
        };
        this.fetchData = this.fetchData.bind(this);  
        this.handleFetch = this.handleFetch.bind(this);  
        this.delete = this.delete.bind(this);  
    }
 
    componentDidMount(){
        this.fetchData();
    }

 
    fetchData(){
        getData(Url,this.state.params).then((res)=>{ 
            this.setState({data:res.data,preloader:false}); 
        });
    }

    handleFetch(params){
        this.setState({params:{...params},preloader:true},()=>{
            this.fetchData();
        });
    }

    delete(id){
        let page=1;
        this.setState({preloader:true,params:{...this.state.params,page}});
        deleteData(Url+'/'+id).then((res)=>{
            if(res.data.status===200){
                this.fetchData();
            }else{
                alert('Not delete');
                this.setState({preloader:false});
            }
        });   
    }
    render() {
        let {preloader,data}=this.state; 
        return (
            <Table
                data={data}
                handleFetch={this.handleFetch.bind(this)}
                preloader={preloader}
                permission="fine-setting"
                title="Fine Setting"
                columns={columns}
                primaryKey="fine_setting_id"    
                addEditUrl={`${this.props.match.url}-action`} 
                delete={this.delete.bind(this)}
            /> 
        );
    }
}
 
export default  withRouter(ListPage); 



// WEBPACK FOOTER //
// ./src/components/Library/FineSetting/index.js